/**
* @param {*} things - Valor a verificar (puede ser cualquier tipo)
* @returns {boolean} - Devuelve true si el valor contiene datos válidos, false si está "vacío"
* @example
* hasThings("Hola") // devuelve true
* hasThings([1, 2, 3]) // devuelve true
* hasThings({ nombre: "Juan" }) // devuelve true
* @example
* hasThings(null) // devuelve false
* hasThings(undefined) // devuelve false
* hasThings("") // devuelve false
* hasThings([]) // devuelve false
* hasThings({}) // devuelve false
* hasThings("Invalid Date") // devuelve false
*/
export const hasThings = (things) => !(
    things === undefined ||
    things === null ||
    things === '' ||
    things?.length === 0 ||
    Object.keys(things).length === 0 ||
    things === "Invalid Date" 
)

export const toBase64 = async (file) => await new Promise((resolve, reject) => {
    if(file instanceof Blob) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    } else reject(new TypeError('toBase64: se esperaba un Blob'))
});

export const urlToFile = async (url) => {
    if (url instanceof File) return url;
    if (!/^(http|https):\/\//.test(url)) return false;
   
    const response = await fetch(url);
    if (!response.ok || !(response.headers.get("Content-Type") || "").startsWith("image/")) {
        return false;
    }
    const blob = await response.blob();
    // Django deduce el Content-Type por la extension: muchas .jpg son PNG y react-pdf revienta
    // ("SOI not found in JPEG"). Detectamos el tipo real por los primeros bytes (magic number).
    const b = new Uint8Array(await blob.slice(0, 4).arrayBuffer());
    const type = b[0] === 0x89 && b[1] === 0x50 ? "image/png"
        : b[0] === 0xff && b[1] === 0xd8 ? "image/jpeg"
        : response.headers.get("Content-Type");
    return new File([blob], url?.split("/").pop(), { type });
}